module.exports = __webpack_public_path__ + "static/media/slide_04.dbd76c52.jpg";